import { traverseNode, isCommentNode } from 'anodum';
import { BLOCK_SETTING_COMMENT } from '../../constants/regexp';

const findBlockSettingComments = (element, childrenSelector) => {
  const foundCommentedSettings = [];

  traverseNode(element, (node) => {
    if (isCommentNode(node)) {
      const matchedResult = node.nodeValue.match(BLOCK_SETTING_COMMENT);

      if (matchedResult && matchedResult[1] === childrenSelector) {
        foundCommentedSettings.push(node);
      }
    }
  });

  return foundCommentedSettings;
};

export default findBlockSettingComments;
